<template>
  <div class="unscoped-content-block" v-html="$props.htmlText"></div>
</template>

<script>
export default {
   data: function () {
    return {}
  },
  props: {
    htmlText: String
  }
}
</script>

<style lang="scss">
@import 'app/assets/stylesheets/_vars.scss';
// includes styles for admin generated reviews section

.unscoped-content-block {
  padding: 1.25rem 0;
  margin: auto;

  h3.sub {
    font-weight: 400;
    margin: 0 0 2.5rem 0;
  }

  p, h3, h4, li, a, .qu {
    font-size: .875rem;
    line-height: 1.25rem;
  }

  h3:not(.auth), p {
    margin-bottom: 1rem;
  }

  .reviews {
    margin-top: 2.5rem;
  }

  ul.rev {
    list-style: none;
    -webkit-overflow-scrolling: touch;
    box-sizing: border-box;
    row-gap: 1.25rem;
    -webkit-column-gap: 1.25rem;
    -moz-column-gap: 1.25rem;
    column-gap: 1.25rem;

    li {
      padding: 0 1.25rem 0 0;
      box-sizing: border-box;
      position: relative;
    }

    .qu {
      display: inline-block;

      &:before,
      &:after {
        content: '"';
      }
    }

    .rgt {
      text-align: right;
    }

    .auth {
      font-weight: 700;
      padding: 0 0 .313rem 0;
    }

    .rev {
      font-weight: 400;
    }

    .rev,
    .qu {
      padding: 0 0 .625rem 0;
    }

    a {
      text-decoration: none;
      cursor: pointer;
      display: block;
      width: 100%;
      text-align: right;
      color: $col_orange;

      &:hover {
        text-decoration: underline;
      }
    }
  }

  @supports (display: grid) {
    ul.rev {
      display: -ms-grid;
      display: grid;
      -ms-grid-columns: 100%;
      grid-template-columns: repeat(1, 100%);
    }
  }

  @media #{$xl-phone} {
    ul.rev {
      -ms-grid-columns: 50%;
      grid-template-columns: repeat(2, calc(50% - .625rem));
    }
  }
}

@media #{$desktop} {
  .unscoped-content-block {
    padding: 1.25rem;

    h2.title {
      font-size: 1.75rem;
    }

    ul.rev {
      -ms-grid-columns: 33%;
      grid-template-columns: repeat(3, calc(33% - .625rem));

      li .qu {
        padding: 0 0 2.625rem;
      }

      a {
        position: absolute;
        bottom: .25rem;
        right: 1.25rem;
      }
    }
  }
}

</style>